import { useGlobalContext } from '../context'


function VoteFinishScreen() {
    const { deathStatement, turns, startNextTurn, players } = useGlobalContext();
    let villagers = players.filter(player => player.class === 'villager' || player.class === 'doctor' || player.class === 'deadfucker' || player.class === 'warrior')
    let werewolves = players.filter(player => player.class === 'werewolf' || player.class === 'babywerewolf')
    if (villagers.length == 1 && werewolves.length == 0)
        return (
            <div className='container border skip'>
                <h4>Vampires Win!</h4>
                <img src={`./img/vampirewin.png`} alt=""/>
                <button onClick={() => window.location.reload()} className='btn btn-dark next'>Play again</button>
            </div>
        )
    else if (villagers.length == 0 && werewolves.length == 0)
        return (
            <div className='container border skip'>
                <h4 className='mt-5'>Vampires Win!</h4>
                <img className='mt-5' src={`./img/vampirewin.png`} alt=""/>
                <button onClick={() => window.location.reload()} className='btn btn-dark next'>Play again</button>
            </div>
        )
    else if (villagers.length == 1 && villagers[0].class === 'doctor')
        return (
            <div className='container border skip'>
                <h4>It's a draw ?!</h4>
                <button onClick={() => window.location.reload()} className='btn btn-dark next'>Play again</button>
            </div>
        )
    else if (villagers.length === players.length)
        return (
            <div className='container border skip'>
                <h4>Villagers Win!</h4>
                <img src={`./img/villagerwin.png`} alt=""/>
                <button onClick={() => window.location.reload()} className='btn btn-dark next'>Play again</button>
            </div>
        )
    else if (werewolves.length === players.length)
        return (
        <div className='container border skip'>
            <h4 >Werewolves Win!</h4>
            <img src={`./img/werewolfwin.png`} alt=""/>
            <button onClick={() => window.location.reload()} className='btn btn-dark next'>Play again</button>
        </div>
        )
    else
        return (
            <div className='container border skip'>
                <h4 className='mt-5'>{deathStatement}</h4>
                <img src="./img/village.png" alt=""/>
                <button onClick={startNextTurn} className='btn btn-dark next'>{`Start the ${turns}. day`}</button>
            </div>
        )
}

export default VoteFinishScreen;